module.exports = __webpack_public_path__ + "assets/favicons/android-chrome-192x192.png";